import { api } from './client.js'

export const FEATURES_OFF = Object.freeze({ registrationEnabled: false, passwordResetEnabled: false, billingEnabled: false })

let cached = null

export function loadPublicConfig({ get = url => api.get(url).then(r => r.data) } = {}) {
  if (!cached)
    cached = get('/api/config/public').catch(() => {
      cached = null
      return FEATURES_OFF
    })
  return cached
}

export const resetPublicConfig = () => {
  cached = null
}
